import TeamMemberFilter from './TeamMemberFilter';
import CertificationStatusFilter from './CertificationStatusFilter';
import TeamFilter from './TeamFilter';
import TopicSelect from '../common/TopicSelect';
import { Box } from 'foundations-components/transitional/components/Box';
import DebouncedSearchInputFilter from './DebouncedSearchInputFilter';
import FilterButton from './FilterButton';
import { useIsAnyFilterSet } from '../../hooks/filtersHooks';
import { commonFilters } from '../../constants/filters';
import MyTeamFiltersWrapper from './MyTeamFiltersWrapper';
import UsageTracker from '../../../../utils/UsageTracker';
import { trackCertificationStatusChange } from '../../utils/trackingUtils';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CertificationStatusesFilterButton = ({
  certificationStatuses,
  setCertificationStatuses
}) => {
  const handleStatusChange = statuses => {
    setCertificationStatuses(statuses);
    if (statuses.length > certificationStatuses.length) {
      const newStatus = statuses.find(status => !certificationStatuses.includes(status));
      if (newStatus) {
        trackCertificationStatusChange(newStatus);
      }
    }
  };
  return /*#__PURE__*/_jsx(FilterButton, {
    filterType: "certification-status",
    isFilterActive: certificationStatuses.length > 0,
    onClear: () => setCertificationStatuses([]),
    children: /*#__PURE__*/_jsx(CertificationStatusFilter, {
      onChange: handleStatusChange,
      selectedCertificationStatuses: certificationStatuses
    })
  });
};
export const TopicSelectFilterButton = ({
  categories,
  setCategories,
  tools,
  setTools
}) => {
  const handleTopicChange = selectedTopics => {
    UsageTracker.track('teamInteraction', {
      action: 'filter-selected',
      type: 'catalog-topic'
    });
    setCategories(selectedTopics.categories);
    setTools(selectedTopics.tools);
  };
  return /*#__PURE__*/_jsx(FilterButton, {
    filterType: "catalog-topic",
    isFilterActive: categories.length > 0 || tools.length > 0,
    onClear: () => {
      setCategories([]);
      setTools([]);
    },
    children: /*#__PURE__*/_jsx(TopicSelect, {
      onChange: handleTopicChange,
      selectedTopics: {
        categories,
        tools
      }
    })
  });
};
export const TeamsFilterButton = ({
  teams,
  setTeams
}) => {
  const handleTeamsChange = selectedTeams => {
    if (selectedTeams.length > teams.length) {
      UsageTracker.track('teamInteraction', {
        action: 'filter-selected',
        type: 'teams'
      });
    }
    setTeams(selectedTeams);
  };
  return /*#__PURE__*/_jsx(FilterButton, {
    filterType: "teams",
    isFilterActive: teams.length > 0,
    onClear: () => setTeams([]),
    children: /*#__PURE__*/_jsx(TeamFilter, {
      onChange: handleTeamsChange,
      selectedTeams: teams
    })
  });
};
export const TeamMemberFilterButton = ({
  users,
  setUsers
}) => {
  const handleUsersChange = selectedUsers => {
    if (selectedUsers.length > users.length) {
      UsageTracker.track('teamInteraction', {
        action: 'filter-selected',
        type: 'team-members'
      });
    }
    setUsers(selectedUsers);
  };
  return /*#__PURE__*/_jsx(FilterButton, {
    filterType: "team-members",
    isFilterActive: users.length > 0,
    onClear: () => setUsers([]),
    children: /*#__PURE__*/_jsx(TeamMemberFilter, {
      onChange: handleUsersChange,
      selectedUsers: users
    })
  });
};
const Filters = ({
  store
}) => {
  const {
    state: {
      certificationStatuses,
      categories,
      tools,
      teams,
      users,
      search
    },
    actions: {
      setCertificationStatuses,
      setCategories,
      setSearch,
      setTools,
      setTeams,
      setUsers,
      resetTableState
    }
  } = store;
  const isAnyFilterSet = useIsAnyFilterSet(store, commonFilters.filter(filter => filter !== 'search') // search has its own clear button
  );
  const handleSearchChange = useCallback(newSearch => {
    setSearch(newSearch);
    if (newSearch) {
      UsageTracker.track('teamInteraction', {
        action: 'search-input',
        value: newSearch
      });
    }
  }, [setSearch]);
  return /*#__PURE__*/_jsxs(MyTeamFiltersWrapper, {
    isAnyFilterSet: isAnyFilterSet,
    onClearAllFilters: resetTableState,
    searchInput: /*#__PURE__*/_jsx(DebouncedSearchInputFilter, {
      onChange: handleSearchChange,
      value: search
    }),
    tableStore: store,
    children: [/*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(CertificationStatusesFilterButton, {
        certificationStatuses: certificationStatuses,
        setCertificationStatuses: setCertificationStatuses
      })
    }), /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(TopicSelectFilterButton, {
        categories: categories,
        setCategories: setCategories,
        setTools: setTools,
        tools: tools
      })
    }), /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(TeamsFilterButton, {
        setTeams: setTeams,
        teams: teams
      })
    }), /*#__PURE__*/_jsx(Box, {
      marginInlineEnd: "600",
      children: /*#__PURE__*/_jsx(TeamMemberFilterButton, {
        setUsers: setUsers,
        users: users
      })
    })]
  });
};
export default Filters;